import { Box, Dialog, DialogTitle, DialogContent, Button, TextField } from "@mui/material";
import { FieldValues, useForm } from "react-hook-form";
import { useState } from "react";
import { toast } from "react-toastify";
import { updateProfile } from "../clients/FixieApiClient";

interface PasswordModalProps {
  open: boolean,
  onClose: () => void
}

export default (props: PasswordModalProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const { register, handleSubmit } = useForm();

  const onSubmit = async (data: FieldValues) => {
    setIsLoading(true);
    const response = await updateProfile(data);
    if (response.ok) {
      toast.success("Your password has been changed");
      props.onClose();
    }
    setIsLoading(false);
  };

  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <DialogTitle>Change Password</DialogTitle>
      <DialogContent>
        <Box component="div" sx={{ minWidth: 280 }}>
          <Box component="form" onSubmit={handleSubmit(onSubmit)} sx={{ mt: 1 }}>
            <TextField {...register('currentPassword')} required fullWidth margin="dense" label="Current Password" type="password" variant="outlined" />
            <TextField {...register('newPassword')} required fullWidth margin="dense" label="New Password" type="password" variant="outlined" />
            <Box textAlign="right">
              <Button
                disabled={isLoading}
                disableElevation
                variant="contained"
                type="submit"
                sx={{ mt: 2, mb: 2, height: "56px" }}
              >
                Change Password
              </Button>
            </Box>
          </Box>
        </Box>
      </DialogContent>

    </Dialog >
  );
}